export default __webpack_public_path__ + "static/media/icon-arrow.087a3aa8.svg";